import React from 'react';
import i18n from 'translation';
import { Alert, Box, Button } from '@mui/material';
import withOptionsWidget, { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget';
import APIRequest, { APIError } from 'system/APIRequest';
import { enqueueSnackbar } from 'notistack';

const widgetTransformations = {
  "ai-summary": {
    newType: "ai-summary-structured"
  },
  "ai-social-personas": {
    newType: "ai-social-personas-structured"
  }
};

// This widget is used to display a message when a widget type is not recognized or cannot be used
function DefaultWidgetContent(props: WithOptionsWidgetProps): JSX.Element {
  let hasReplacement = false;
  if (props.widget.name in widgetTransformations) {
    hasReplacement = true;
  }

  return (
    <Box>
      {!hasReplacement &&
        <Alert
          severity="error"
          sx={{margin:"20px"}}
          >
          {i18n.t("widgets.unknown-widget-error")}
        </Alert>
      }
      {hasReplacement &&
        <Alert
          severity="info"
          sx={{margin:"20px"}}
          >
          {i18n.t("widgets.replacement-widget-error")}
          <br/><br/>
          <Button
            onClick={() => {
              if (!(props.widget.name in widgetTransformations)) {
                enqueueSnackbar(i18n.t("widgets.unknown-widget-error"), { variant: "error", persist: true });
                return;
              }

              const newWidgetType = widgetTransformations[props.widget.name as keyof typeof widgetTransformations].newType;
              APIRequest(`obj/dashboard-widget/${props.widget.id}`, {}, {
                method: 'PUT',
                body: JSON.stringify({name: newWidgetType})
              }).then(() => {
                window.location.reload();
              }).catch((reason: APIError) => {
                enqueueSnackbar(`${i18n.t("error")}: ${reason.message}`, { variant: "error", persist: true });
              });
            }}
            variant="contained"
            color="primary"
            >
            {i18n.t("widgets.replacement-widget-button")}
          </Button>
        </Alert>
      }
    </Box>
  );
}

export default withOptionsWidget(DefaultWidgetContent, {
  hasSettingsDialog: false
});